import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { onViewChange, allToTallest } from '@/resources/assets/js/modules/utils';

class InfoCards {
  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.rail = this.root.querySelector('.InfoCards-rail');
    this.cardsTitles = [...this.root.querySelectorAll('.InfoCards-rail .InfoCard h3')];
    this.#init();
  }

  #init() {
    allToTallest(this.cardsTitles);
    onViewChange(allToTallest.bind(this, this.cardsTitles));
    this.#parallaxScroll();
  }

  #parallaxScroll() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(this.rail, {
      x: () => this.rail.scrollWidth * -1,
      xPercent: 100,
      scrollTrigger: {
        trigger: this.rail,
        start: 'center center',
        end: '+=2300px',
        pin: this.rail,
        scrub: 1,
        // markers: true,
        invalidateOnRefresh: true,
      }
    })
  }
}

[...document.querySelectorAll('.InfoCards')].forEach(node => {
  new InfoCards(node);
});